import React from 'react';

import { Header } from 'semantic-ui-react';

const propTypes = {};
const defaultProps = {};

export default function FaqsPageHeader() {
  return (
    <div className="tab-header">
      <Header as="h3">FAQs Page</Header>
      <p>Manage your FAQs page. Questions and groups you create will appear here.</p>
    </div>
  );
}

FaqsPageHeader.propTypes = propTypes;
FaqsPageHeader.defaultProps = defaultProps;
